<template>
  <div class="app-semaphore" :class="cssClass"></div>
</template>

<script>

export default {
  props: {
    value: {
      type: Number,
      required: false,
    },
  },
  computed: {
    cssClass () {
      if (!this.value) {
        return 'app-semaphore-value-invalid';
      }

      if (this.value === 1) {
        return 'app-semaphore-value-insufficient';
      }

      if (this.value === 2) {
        return 'app-semaphore-value-sufficient';
      }

      if (this.value === 3) {
        return 'app-semaphore-value-fair';
      }

      if (this.value === 4) {
        return 'app-semaphore-value-good';
      }

      if (this.value === 5) {
        return 'app-semaphore-value-excellent';
      }

      return 'app-semaphore-value-invalid';
    },
  },
};

</script>

<style lang="scss">

$app-semaphore-value-insufficient: #c60609 !default;
$app-semaphore-value-sufficient: #f3722c !default;
$app-semaphore-value-fair: #f8961e !default;
$app-semaphore-value-good: #f9c74f !default;
$app-semaphore-value-excellent: #90be6d !default;
$app-semaphore-value-invalid: #e6ecef !default;

.app-semaphore {
  width: 15px;
  height: 15px;
  border-radius: 10px;
  border: 1px solid black;
  margin-right: 10px;
  display: inline-block;

  &.app-semaphore-value-insufficient {
    background-color: $app-semaphore-value-insufficient;
  }

  &.app-semaphore-value-sufficient {
    background-color: $app-semaphore-value-sufficient;
  }

  &.app-semaphore-value-fair {
    background-color: $app-semaphore-value-fair;
  }

  &.app-semaphore-value-good {
    background-color: $app-semaphore-value-good;
  }

  &.app-semaphore-value-excellent {
    background-color: $app-semaphore-value-excellent;
  }

  &.app-semaphore-value-invalid {
    background-color: $app-semaphore-value-invalid;
  }
}

</style>
